import React from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';
import { PlayIcon, ThumbsUpIcon, ThumbsDownIcon, ShareArrowIcon, WandIcon, MoreHorizontalIcon, TriangleDownIcon } from '../../utils/icons';
import MediumButton from './MediumButton';
import SmallButton from './SmallButton';

const PauseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="6" width="3" height="12" rx="1" fill="currentColor"/>
    <rect x="13" y="6" width="3" height="12" rx="1" fill="currentColor"/>
  </svg>
);

const SongCell = ({
  title,
  genres,
  image,
  onPlay,
  onSelect,
  onThumbsUp,
  onThumbsDown,
  onShare,
  onAdd,
  onMore,
  onChatBubble,
  isSelected = false,
  isPlaying = false
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      className="flex items-center justify-between px-4 py-3 cursor-pointer transition-colors duration-200 rounded-2xl"
      style={{
        backgroundColor: isSelected ? colors.bg.fog.thin : 'transparent'
      }}
      onClick={onSelect}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex gap-4 items-center">
        {/* Thumbnail with Play Button */}
        <div
          className="relative w-[67px] h-[86px] rounded-xl flex-shrink-0 overflow-hidden cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            onPlay();
          }}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: image ? `url(${image})` : 'none',
              backgroundColor: colors.bg.fog.thin
            }}
          />
          <div className="absolute inset-0 bg-black/50 rounded-xl" />

          {/* Duration Badge */}
          <div
            className="absolute bottom-1 right-1 px-2 py-1 rounded-full backdrop-blur-md"
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.1)'
            }}
          >
            <p
              style={{
                ...typography.timecode,
                color: colors.text.primary,
                fontSize: '10px'
              }}
            >
              2:56
            </p>
          </div>

          {/* Play/Pause Icon */}
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center pointer-events-none"
            style={{ color: colors.text.primary }}
          >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
          </div>
        </div>

        {/* Song Info */}
        <div className="flex flex-col gap-2 min-w-[200px]">
          <div className="flex flex-col">
            <div className="flex gap-1 items-center">
              <p
                className="truncate"
                style={{
                  ...typography.medium.title,
                  color: isPlaying ? colors.accent.brand : colors.text.primary
                }}
              >
                {title}
              </p>
              <div
                className="px-1.5 py-0.5 rounded-full flex-shrink-0"
                style={{
                  backgroundColor: 'rgba(253, 66, 156, 0.1)'
                }}
              >
                <p
                  style={{
                    ...typography.xsmall,
                    color: colors.accent.brand,
                    fontSize: '12px'
                  }}
                >
                  v4.5
                </p>
              </div>
            </div>
            <p
              className="truncate"
              style={{
                ...typography.xsmall.regular,
                color: colors.text.secondary
              }}
            >
              {genres}
            </p>
          </div>

          {/* Small Action Buttons */}
          <div className="flex gap-2 items-center">
            <SmallButton
              variant="secondary"
              leftIcon={<ThumbsUpIcon />}
              onClick={(e) => {
                e.stopPropagation();
                onThumbsUp();
              }}
            />
            <SmallButton
              variant="secondary"
              leftIcon={<ThumbsDownIcon />}
              onClick={(e) => {
                e.stopPropagation();
                onThumbsDown();
              }}
            />
            <SmallButton
              variant="secondary"
              leftIcon={<ShareArrowIcon />}
              onClick={(e) => {
                e.stopPropagation();
                onShare();
              }}
            />
            <SmallButton
              variant="secondary"
              leftIcon={<WandIcon />}
              onClick={(e) => {
                e.stopPropagation();
                if (onChatBubble) {
                  onChatBubble();
                } else {
                  onSelect();
                }
              }}
            />
          </div>
        </div>
      </div>

      {/* Right Side Buttons */}
      <div className="flex gap-2 items-center">
        {isHovered && (
          <MediumButton
            variant="secondary"
            text="Remix/Edit"
            rightIcon={<TriangleDownIcon />}
            onClick={(e) => {
              e.stopPropagation();
              onMore();
            }}
          />
        )}
        <MediumButton
          variant="secondary"
          leftIcon={<MoreHorizontalIcon />}
          onClick={(e) => {
            e.stopPropagation();
            onMore();
          }}
        />
      </div>
    </div>
  );
};

export default SongCell;
